import { MOTION } from '../lib/motion'

const MayaSidebarToolIcon = ({ src }) => (
  <img
    src={`${process.env.PUBLIC_URL}${src}`}
    alt=""
    className="maya-sidebar-tool-icon"
    aria-hidden="true"
    draggable={false}
  />
)

const TRANSFORM_TOOLS = [
  { id: 'select', label: 'Select Tool', src: '/images/maya/toolbox/select.png', active: true },
  { id: 'lasso', label: 'Lasso Select Tool', src: '/images/maya/toolbox/lasso.png' },
  { id: 'paint-select', label: 'Paint Selection Tool', src: '/images/maya/toolbox/paint-select.png' },
  { id: 'move', label: 'Move Tool', src: '/images/maya/toolbox/move.png' },
  { id: 'rotate', label: 'Rotate Tool', src: '/images/maya/toolbox/rotate.png' },
  { id: 'scale', label: 'Scale Tool', src: '/images/maya/toolbox/scale.png' },
]

const LAYOUT_TOOLS = [
  {
    id: 'channel-box',
    label: 'Channel Box',
    src: '/images/maya/toolbox/toolbox-channel-box.png',
    active: true,
  },
  {
    id: 'outliner-tree',
    label: 'Outliner',
    src: '/images/maya/toolbox/toolbox-outliner-tree.png',
    active: true,
  },
]

const MayaSidebarToolbox = ({ introStaggerMs = MOTION.ms.introStagger }) => (
  <div
    className="maya-sidebar-toolbox site-intro-item"
    style={{ '--intro-delay': `${2 * introStaggerMs}ms` }}
    role="toolbar"
    aria-label="Maya tools"
  >
    {TRANSFORM_TOOLS.map((tool) => (
      <button
        key={tool.id}
        type="button"
        className={`maya-sidebar-tool-btn${tool.active ? ' is-active' : ' is-disabled'}`}
        aria-label={tool.label}
        title={tool.label}
        disabled={!tool.active}
        aria-disabled={!tool.active}
      >
        <MayaSidebarToolIcon src={tool.src} />
      </button>
    ))}

    <div className="maya-sidebar-toolbox-sep" aria-hidden="true" />

    {LAYOUT_TOOLS.map((tool) => (
      <button
        key={tool.id}
        type="button"
        className={`maya-sidebar-tool-btn${tool.active ? ' is-active' : ' is-disabled'}`}
        aria-label={tool.label}
        title={tool.label}
        disabled={!tool.active}
        aria-disabled={!tool.active}
      >
        <MayaSidebarToolIcon src={tool.src} />
      </button>
    ))}
  </div>
)

export default MayaSidebarToolbox
